var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-cbt-modal-component",
      attrs: { "data-grm-comp": "RoomCBTModal" },
    },
    [
      _c("div", { staticClass: "room-cbt-modal flex flex-col" }, [
        _c(
          "div",
          { staticClass: "room-cbt-header" },
          [
            _c("h6", [_vm._v("전자문제집")]),
            _c("GrmCloseBtn", { on: { click: _vm.onClose } }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mt-6 min-h-0 flex-1 overflow-hidden flex flex-col" },
          [
            _c(
              "div",
              { staticClass: "flex justify-end gap-x-1" },
              [
                _c("GrmBtn", { on: { click: _vm.onOpenRoomCBTLog } }, [
                  _vm._v("출제 이력"),
                ]),
                _c("GrmBtn", { on: { click: _vm.onAddCBT } }, [
                  _vm._v("문제집 추가"),
                ]),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "room-cbt-list-wrapper min-h-0 flex-1 overflow-y-auto",
              },
              [_c("RoomCBTList")],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }